var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUp = function SvgUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0125411251,2.00838294 C-0.153916274,2.21272374 1.53964426,5.50356978 5.09322274,11.8809211 C1.53964426,18.2594203 -0.154490265,21.5502663 0.010819152,21.7534592 C0.122173412,21.892365 8.09433485,18.601519 23.9273035,11.8809211 C8.14943799,5.09488817 0.177850542,1.80404213 0.0125411251,2.00838294 Z",
    transform: "translate(11.963550, 11.878551) rotate(-90.000000) translate(-11.963550, -11.878551) "
  })));
};
export { SvgUp as ReactComponent };